import { ACHTransactionsType } from '../giftcard-ach-service.types';

export const ACHTransactions: ACHTransactionsType = {
  transferList: [
    {
      id: '493fc61f-bf0a-45bc-89c5-57f3dc0075d0',
      externalId: '1a1d2583-99f7-f011-acd5-02ab38c54207',
      parentTransferId: null,
      parentTransferExternalId: null,
      fundingTransferId: '191d2583-99f7-f011-acd5-02ab38c54207',
      fundedTransferId: null,
      summaryId: 'abed09b3-add2-4925-b393-6769d34f8560',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '952e1839-75f2-4d4b-9949-3760579583b8',
      sourceLocationId: '952e1839-75f2-4d4b-9949-3760579583b8',
      sourceLocationExternalId: 'e3bec8d4-1e78-4d2d-aea0-2346a191dd82',
      sourceLocationName: 'Tower Sq (DON"T EDIT)',
      destinationLocationId:
        '1b63163d-1aba-4944-bbc1-ebc495d9dc5c-POOL_ACCOUNT',
      destinationLocationExternalId: 'aa8e421d-af37-4d27-9197-203471364cfd',
      destinationLocationName: 'palmlanedev',
      sourceFundingAccountId: '246c1b0d-1944-4e09-8cd3-85863395f0fa',
      sourceFundingAccountExternalId: 'eb38c6c2-11e8-4822-a33a-fa82813df8da',
      sourceFundingAccountName: 'SANDBOX TEST BANK',
      destinationFundingAccountId: 'db0c30af-89ab-4075-9ac5-14a81f93b076',
      destinationFundingAccountExternalId:
        '3377edc5-410f-4839-94bf-f9fd40325da4',
      destinationFundingAccountName: 'SANDBOX TEST BANK',
      amount: 0.01,
      amountFormatted: '0.01',
      fullAmount: 20000.01,
      currencyCode: null,
      debitAccount: 'LOCATION',
      resolutionTime: null,
      resolutionComment: null,
      partialTransfer: true,
      status: 'PENDING',
      links: {
        cancel: {
          type: 'application/vnd.dwolla.v1.hal+json',
          'resource-type': 'transfer',
          href: 'https://api-sandbox.dwolla.com/transfers/1a1d2583-99f7-f011-acd5-02ab38c54207',
        },
        'destination-funding-source': {
          type: 'application/vnd.dwolla.v1.hal+json',
          'resource-type': 'funding-source',
          href: 'https://api-sandbox.dwolla.com/funding-sources/3377edc5-410f-4839-94bf-f9fd40325da4',
        },
        'funding-transfer': {
          type: 'application/vnd.dwolla.v1.hal+json',
          'resource-type': 'transfer',
          href: 'https://api-sandbox.dwolla.com/transfers/191d2583-99f7-f011-acd5-02ab38c54207',
        },
        'source-funding-source': {
          type: 'application/vnd.dwolla.v1.hal+json',
          'resource-type': 'funding-source',
          href: 'https://api-sandbox.dwolla.com/funding-sources/eb38c6c2-11e8-4822-a33a-fa82813df8da',
        },
        destination: {
          type: 'application/vnd.dwolla.v1.hal+json',
          'resource-type': 'customer',
          href: 'https://api-sandbox.dwolla.com/customers/aa8e421d-af37-4d27-9197-203471364cfd',
        },
        self: {
          type: 'application/vnd.dwolla.v1.hal+json',
          'resource-type': 'transfer',
          href: 'https://api-sandbox.dwolla.com/transfers/1a1d2583-99f7-f011-acd5-02ab38c54207',
        },
        source: {
          type: 'application/vnd.dwolla.v1.hal+json',
          'resource-type': 'customer',
          href: 'https://api-sandbox.dwolla.com/customers/e3bec8d4-1e78-4d2d-aea0-2346a191dd82',
        },
      },
      failureReason: null,
      failureExceptions: [],
      auditEvents: [
        {
          id: '69722b7c7b1d177275055fbb',
          eventName: 'CREATED',
          traceId: null,
          transferId: '493fc61f-bf0a-45bc-89c5-57f3dc0075d0',
          eventTime: '2026-01-22T13:50:56.152Z',
          interventionRequired: false,
          resolved: false,
          resolutionTime: null,
          resolutionComment: null,
          externalStatuses: {},
          additionalDetails: null,
        },
        {
          id: '69722b837b1d177275055fc2',
          eventName: 'SUBMITTED_TO_DWOLLA',
          traceId: null,
          transferId: '493fc61f-bf0a-45bc-89c5-57f3dc0075d0',
          eventTime: '2026-01-22T13:51:03.106Z',
          interventionRequired: false,
          resolved: false,
          resolutionTime: null,
          resolutionComment: null,
          externalStatuses: {},
          additionalDetails: 'test',
        },
        {
          id: '69722b837b1d177275055fc3',
          eventName: 'WEBHOOK_UPDATE',
          traceId: null,
          transferId: '493fc61f-bf0a-45bc-89c5-57f3dc0075d0',
          eventTime: '2026-01-22T13:52:03.753Z',
          interventionRequired: false,
          resolved: false,
          resolutionTime: null,
          resolutionComment: null,
          externalStatuses: {},
          additionalDetails: '',
        },
        {
          id: '69722b837b1d177275055fc5',
          eventName: 'WEBHOOK_UPDATE',
          traceId: null,
          transferId: '493fc61f-bf0a-45bc-89c5-57f3dc0075d0',
          eventTime: '2026-01-22T13:52:03.867Z',
          interventionRequired: false,
          resolved: false,
          resolutionTime: null,
          resolutionComment: null,
          externalStatuses: {},
          additionalDetails:
            'Context : customer_transfer_created Transfer Info : {"id":"1a1d2583-99f7-f011-acd5-02ab38c54207","status":"pending","amount":{"value":"0.01","currency":"USD"},"created":"2026-01-22T13:52:02.637Z","_links":{"cancel":{"resource-type":"transfer","href":"https://api-sandbox.dwolla.com/transfers/1a1d2583-99f7-f011-acd5-02ab38c54207","type":"application/vnd.dwolla.v1.hal+json"},"destination-funding-source":{"resource-type":"funding-source","href":"https://api-sandbox.dwolla.com/funding-sources/3377edc5-410f-4839-94bf-f9fd40325da4","type":"application/vnd.dwolla.v1.hal+json"},"funding-transfer":{"resource-type":"transfer","href":"https://api-sandbox.dwolla.com/transfers/191d2583-99f7-f011-acd5-02ab38c54207","type":"application/vnd.dwolla.v1.hal+json"},"source-funding-source":{"resource-type":"funding-source","href":"https://api-sandbox.dwolla.com/funding-sources/eb38c6c2-11e8-4822-a33a-fa82813df8da","type":"application/vnd.dwolla.v1.hal+json"},"destination":{"resource-type":"customer","href":"https://api-sandbox.dwolla.com/customers/aa8e421d-af37-4d27-9197-203471364cfd","type":"application/vnd.dwolla.v1.hal+json"},"self":{"resource-type":"transfer","href":"https://api-sandbox.dwolla.com/transfers/1a1d2583-99f7-f011-acd5-02ab38c54207","type":"application/vnd.dwolla.v1.hal+json"},"source":{"resource-type":"customer","href":"https://api-sandbox.dwolla.com/customers/e3bec8d4-1e78-4d2d-aea0-2346a191dd82","type":"application/vnd.dwolla.v1.hal+json"}},"isSuccess":true,"statusCode":0} Failure Reason Info : null',
        },
        {
          id: '69722b837b1d177275055fc7',
          eventName: 'WEBHOOK_UPDATE',
          traceId: null,
          transferId: '1a1d2583-99f7-f011-acd5-02ab38c54207',
          eventTime: '2026-01-22T13:52:03.884Z',
          interventionRequired: false,
          resolved: false,
          resolutionTime: null,
          resolutionComment: null,
          externalStatuses: {},
          additionalDetails: 'Fund Transfer Event : customer_transfer_created',
        },
        {
          id: '69722b8a7b1d177275055fd6',
          eventName: 'WEBHOOK_UPDATE',
          traceId: null,
          transferId: '493fc61f-bf0a-45bc-89c5-57f3dc0075d0',
          eventTime: '2026-01-22T13:52:10.895Z',
          interventionRequired: false,
          resolved: false,
          resolutionTime: null,
          resolutionComment: null,
          externalStatuses: {},
          additionalDetails:
            'Context : customer_bank_transfer_created Transfer Info : {"id":"1a1d2583-99f7-f011-acd5-02ab38c54207","status":"pending","amount":{"value":"0.01","currency":"USD"},"created":"2026-01-22T13:52:02.637Z","_links":{"cancel":{"resource-type":"transfer","href":"https://api-sandbox.dwolla.com/transfers/1a1d2583-99f7-f011-acd5-02ab38c54207","type":"application/vnd.dwolla.v1.hal+json"},"destination-funding-source":{"resource-type":"funding-source","href":"https://api-sandbox.dwolla.com/funding-sources/3377edc5-410f-4839-94bf-f9fd40325da4","type":"application/vnd.dwolla.v1.hal+json"},"funding-transfer":{"resource-type":"transfer","href":"https://api-sandbox.dwolla.com/transfers/191d2583-99f7-f011-acd5-02ab38c54207","type":"application/vnd.dwolla.v1.hal+json"},"source-funding-source":{"resource-type":"funding-source","href":"https://api-sandbox.dwolla.com/funding-sources/eb38c6c2-11e8-4822-a33a-fa82813df8da","type":"application/vnd.dwolla.v1.hal+json"},"destination":{"resource-type":"customer","href":"https://api-sandbox.dwolla.com/customers/aa8e421d-af37-4d27-9197-203471364cfd","type":"application/vnd.dwolla.v1.hal+json"},"self":{"resource-type":"transfer","href":"https://api-sandbox.dwolla.com/transfers/1a1d2583-99f7-f011-acd5-02ab38c54207","type":"application/vnd.dwolla.v1.hal+json"},"source":{"resource-type":"customer","href":"https://api-sandbox.dwolla.com/customers/e3bec8d4-1e78-4d2d-aea0-2346a191dd82","type":"application/vnd.dwolla.v1.hal+json"}},"isSuccess":true,"statusCode":0} Failure Reason Info : null',
        },
        {
          id: '69722b8a7b1d177275055fd8',
          eventName: 'WEBHOOK_UPDATE',
          traceId: null,
          transferId: '191d2583-99f7-f011-acd5-02ab38c54207',
          eventTime: '2026-01-22T13:52:10.916Z',
          interventionRequired: false,
          resolved: false,
          resolutionTime: null,
          resolutionComment: null,
          externalStatuses: {},
          additionalDetails:
            'Fund Transfer Event : customer_bank_transfer_created',
        },
        {
          id: '69722b8c7b1d177275055ff3',
          eventName: 'WEBHOOK_UPDATE',
          traceId: null,
          transferId: '493fc61f-bf0a-45bc-89c5-57f3dc0075d0',
          eventTime: '2026-01-22T13:52:12.984Z',
          interventionRequired: false,
          resolved: false,
          resolutionTime: null,
          resolutionComment: null,
          externalStatuses: {},
          additionalDetails:
            'Context : customer_transfer_created Transfer Info : {"id":"1a1d2583-99f7-f011-acd5-02ab38c54207","status":"pending","amount":{"value":"0.01","currency":"USD"},"created":"2026-01-22T13:52:02.637Z","_links":{"cancel":{"resource-type":"transfer","href":"https://api-sandbox.dwolla.com/transfers/1a1d2583-99f7-f011-acd5-02ab38c54207","type":"application/vnd.dwolla.v1.hal+json"},"destination-funding-source":{"resource-type":"funding-source","href":"https://api-sandbox.dwolla.com/funding-sources/3377edc5-410f-4839-94bf-f9fd40325da4","type":"application/vnd.dwolla.v1.hal+json"},"funding-transfer":{"resource-type":"transfer","href":"https://api-sandbox.dwolla.com/transfers/191d2583-99f7-f011-acd5-02ab38c54207","type":"application/vnd.dwolla.v1.hal+json"},"source-funding-source":{"resource-type":"funding-source","href":"https://api-sandbox.dwolla.com/funding-sources/eb38c6c2-11e8-4822-a33a-fa82813df8da","type":"application/vnd.dwolla.v1.hal+json"},"destination":{"resource-type":"customer","href":"https://api-sandbox.dwolla.com/customers/aa8e421d-af37-4d27-9197-203471364cfd","type":"application/vnd.dwolla.v1.hal+json"},"self":{"resource-type":"transfer","href":"https://api-sandbox.dwolla.com/transfers/1a1d2583-99f7-f011-acd5-02ab38c54207","type":"application/vnd.dwolla.v1.hal+json"},"source":{"resource-type":"customer","href":"https://api-sandbox.dwolla.com/customers/e3bec8d4-1e78-4d2d-aea0-2346a191dd82","type":"application/vnd.dwolla.v1.hal+json"}},"isSuccess":true,"statusCode":0} Failure Reason Info : null',
        },
        {
          id: '69722b8d7b1d177275055ff9',
          eventName: 'WEBHOOK_UPDATE',
          traceId: null,
          transferId: '1a1d2583-99f7-f011-acd5-02ab38c54207',
          eventTime: '2026-01-22T13:52:13.001Z',
          interventionRequired: false,
          resolved: false,
          resolutionTime: null,
          resolutionComment: null,
          externalStatuses: {},
          additionalDetails: 'Fund Transfer Event : customer_transfer_created',
        },
      ],
      sourceAccountTransferStatusList: [
        'CUSTOMER_TRANSFER_CREATED',
        'CUSTOMER_BANK_TRANSFER_CREATED',
      ],
      destinationAccountTransferStatusList: ['CUSTOMER_TRANSFER_CREATED'],
      transferStartDate: '2026-01-17T00:00:00Z',
      transferEndDate: '2026-01-21T23:59:59.999Z',
      createdDate: '2026-01-22T13:51:56.152Z',
      modifiedDate: '2026-01-22T13:52:13.009Z',
    },
  ],
  pageIndex: 0,
  pageSize: 10,
  total: 103,
  totalRecordCount: 1028,
};
